import axios from "axios";
import cleanDeep from "clean-deep";
import { addDays, addHours, differenceInCalendarDays, format, isValid, parse, set, subDays } from "date-fns";
import { NotificationManager } from "react-notifications";
import { constructQueryParams } from "../../components/common/validation/Validators.js";
import { Actions as EMPLOYEEACTIONS } from "./employeeActions.js";

import _ from "lodash";
import apiURL from "./apiURL";
import { createRequest } from "@/common/helpers/RequestHelpers.js";

const settingsRequest = createRequest({
	urlPath: "/settings",
});

const leaveRequest = createRequest({
	urlPath: "/settings/leave",
	// local: true
});

let getLeaveAbortController;

// const apiURL = "http://localhost:3000"

// const orgId = window.location.pathname == '/xero/callback/' ? window.localStorage.getItem('organisation') : window.location.pathname.split('/')[2];

// types of action
const Types = {
	LEAVE_BALANCE_REPORT_MODAL: "LEAVE_BALANCE_REPORT_MODAL",
	LEAVE_GENERATING_BALANCE_REPORT: "LEAVE_GENERATING_BALANCE_REPORT",
	LEAVE_OPEN_MODAL: "LEAVE_OPEN_MODAL",
	LEAVE_SHOW_COMMENTS: "LEAVE_SHOW_COMMENTS",
	LEAVE_SHOW_ATTACHMENTS: "LEAVE_SHOW_ATTACHMENTS",
	LEAVE_SHOW_CANCEL_LEAVE: "LEAVE_SHOW_CANCEL_LEAVE",
	LEAVE_BREAKDOWN: "LEAVE_BREAKDOWN",
	LEAVE_BREAKDOWN_STATUS: "LEAVE_BREAKDOWN_STATUS",
	LEAVE_SAVING: "LEAVE_SAVING",
	LEAVE_SAVE_CURRENT: "LEAVE_SAVE_CURRENT",
	LEAVE_ATTACHMENT_DOWNLOADING: "LEAVE_ATTACHMENT_DOWNLOADING",
	LEAVE_ATTACHMENT_DOWNLOADED: "LEAVE_ATTACHMENT_DOWNLOADED",
	LEAVE_UPDATE_BALANCES: "LEAVE_UPDATE_BALANCES",
	LEAVE_UPDATING_BALANCES: "LEAVE_UPDATING_BALANCES",
	LEAVE_UPDATING: "LEAVE_UPDATING",
	LEAVE_UPDATE: "LEAVE_UPDATE",
	LEAVE_UPDATING_MODAL: "LEAVE_UPDATING_MODAL",
	LEAVE_UPDATE_MODAL: "LEAVE_UPDATE_MODAL",
	LEAVE_UPDATING_TIMELINE: "LEAVE_UPDATING_TIMELINE",
	LEAVE_UPDATE_TIMELINE: "LEAVE_UPDATE_TIMELINE",
	LEAVE_TYPES_UPDATING: "LEAVE_TYPES_UPDATING",
	LEAVE_TYPES_UPDATE: "LEAVE_TYPES_UPDATE",
	LEAVE_TYPES_PERMISSIONS: "LEAVE_TYPES_PERMISSIONS",
	LEAVE_LOCK_DATE: "LEAVE_LOCK_DATE",
	LEAVE_FUTURE_LOCK_DATE: "LEAVE_FUTURE_LOCK_DATE",
	LEAVE_SETTINGS_UPDATING: "LEAVE_SETTINGS_UPDATING",
	LEAVE_SETTINGS_UPDATE: "LEAVE_SETTINGS_UPDATE",
	LEAVE_PERMISSIONS_UPDATING: "LEAVE_PERMISSIONS_UPDATING",
	LEAVE_PERMISSIONS_UPDATE: "LEAVE_PERMISSIONS_UPDATE",
	LEAVE_IMPORT_SHOW_MODAL: "LEAVE_IMPORT_SHOW_MODAL",
	LEAVE_IMPORT_DATA_PROCESSING: "LEAVE_IMPORT_DATA_PROCESSING",
	LEAVE_IMPORT_DATA_PROCESSED: "LEAVE_IMPORT_DATA_PROCESSED",
	LEAVE_IMPORT_UPLOAD_TEMPLATE: "LEAVE_IMPORT_UPLOAD_TEMPLATE",
	LEAVE_FILE_UPLOADING: "LEAVE_FILE_UPLOADING",
	LEAVE_FILE_UPLOADED: "LEAVE_FILE_UPLOADED",
	LEAVE_TAB: "LEAVE_TAB",
	LEAVE_DETAILED_REPORT_DOWNLOADING: "LEAVE_DETAILED_REPORT_DOWNLOADING",
	LEAVE_UPDATE_FIELD: "LEAVE_UPDATE_FIELD",
	LEAVE_CARRYOVER_STATUS: "LEAVE_CARRYOVER_STATUS",
	LEAVE_CARRYOVER_MODAL: "LEAVE_CARRYOVER_MODAL",
	LEAVE_CARRYOVER_MAX: "LEAVE_CARRYOVER_MAX",
	LEAVE_SET_FUTURE_BALANCE: "LEAVE_SET_FUTURE_BALANCE",
	LEAVE_UPDATE_SINGULAR_BALANCE: "LEAVE_UPDATE_SINGULAR_BALANCE",
	LEAVE_MULTI_OPTION_FIELD: "LEAVE_MULTI_OPTION_FIELD",
	LEAVE_MODAL_UPDATE_FIELD: "LEAVE_MODAL_UPDATE_FIELD",
	LEAVE_UPDATE_MODAL_STATUS: "LEAVE_UPDATE_MODAL_STATUS",
	LEAVE_MODAL_UPDATE_BREAKDOWN: "LEAVE_MODAL_UPDATE_BREAKDOWN",
	LEAVE_MODAL_MAP_BREAKDOWN: "LEAVE_MODAL_MAP_BREAKDOWN",
	LEAVE_MODAL_CONTINUOUS: "LEAVE_MODAL_CONTINUOUS",
	LEAVE_UPDATE_MODAL_DETAILS: "LEAVE_UPDATE_MODAL_DETAILS",
	LEAVE_MODAL_DETAILS_LOADING: "LEAVE_MODAL_DETAILS_LOADING",
	LEAVE_UPDATE_RULE: "LEAVE_UPDATE_RULE",
	LEAVE_ADD_RULE: "LEAVE_ADD_RULE",
	LEAVE_GET_RULES: "LEAVE_GET_RULES",
	LEAVE_SAVE_RULES: "LEAVE_SAVE_RULES",
	LEAVE_SAVE_MARKED: "LEAVE_SAVE_MARKED",
	LEAVE_SET_MARKED_MODAL: "LEAVE_SET_MARKED_MODAL",
};

const modalUpdateStatus = (balances, holidays, leave) => ({
	type: Types.LEAVE_UPDATE_MODAL_STATUS,
	balances,
	holidays,
	leave,
});

const setMaxCarryover = (maxCarryover, maxPayable, carryoverAll) => ({
	type: Types.LEAVE_CARRYOVER_MAX,
	maxCarryover,
	maxPayable,
	carryoverAll,
});

const leaveCarryoverModal = (status) => ({
	type: Types.LEAVE_CARRYOVER_MODAL,
	status,
});

const leaveBreakdownStatus = (processing) => ({
	type: Types.LEAVE_BREAKDOWN_STATUS,
	processing,
});

const leaveBreakdown = (payload) => ({
	type: Types.LEAVE_BREAKDOWN,
	payload,
});

const leaveGetBreakdown = (id) => {
	return (dispatch, getState) => {
		const state = getState();

		dispatch(leaveBreakdownStatus(true));

		fetch(apiURL + `/settings/leave/${id}/breakdown`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((response) => {
				dispatch(leaveBreakdown(response));
				dispatch(updateModalStatus());
			});
	};
};

const leaveCarryoverStatus = (processing) => ({
	type: Types.LEAVE_CARRYOVER_STATUS,
	processing,
});

const processLeaveCarryover = (method, maxHours) => {
	return (dispatch, getState) => {
		const state = getState();

		dispatch(leaveCarryoverStatus(true));

		fetch(apiURL + `/settings/leave/carryover`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({ method, maxHours }),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((response) => {
				dispatch(leaveCarryoverStatus(false));
			});
	};
};

// actions

const leaveTab = (tab) => ({
	type: Types.LEAVE_TAB,
	tab,
});

const leaveUpdatingBalances = () => ({
	type: Types.LEAVE_UPDATING_BALANCES,
});

const leaveUpdateBalances = (response) => ({
	type: Types.LEAVE_UPDATE_BALANCES,
	payload: response,
});

const getChildRelatedBalance = ({ type, date, agreement, child }) => {
	return async (dispatch, getState) => {
		dispatch(leaveUpdatingBalances());

		const qs = Object.entries({ type, date, agreement, child })?.reduce((prev, curr) => {
			const [key, value] = curr;
			if (typeof value != "undefined") prev[key] = value;
			return prev;
		}, {});

		await fetch(apiURL + `/settings/parental-leave/balance?${new URLSearchParams(qs).toString()}`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(leaveUpdateBalances(data));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Getting Child Related Leave Balance", "Child Related Leave");
			});
	};
};
const leaveGetBalances = (until, department) => {
	return (dispatch, getState) => {
		dispatch(leaveUpdatingBalances());

		const url = department ? `/balance/team/${department}` : `/balances`;

		leaveRequest({
			path: url,
			method: "GET",
			query: { until },
		})
			.then(({ data }) => {
				dispatch(leaveUpdateBalances(data));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Getting Leave Balances", "Leave Balances");
			});
	};
};

const leaveUpdating = ({ from, to }) => ({
	type: Types.LEAVE_UPDATING,
	from,
	to,
});

const leaveUpdatingModal = ({ from, to }) => ({
	type: Types.LEAVE_UPDATING_MODAL,
	from,
	to,
});

const leaveUpdatingTimeline = ({ from, to }) => ({
	type: Types.LEAVE_UPDATING_TIMELINE,
	from,
	to,
});

const leaveUpdate = ({ leave, from, to }) => ({
	type: Types.LEAVE_UPDATE,
	leave,
	from,
	to,
});

const leaveUpdateModal = ({ leave, from, to }) => ({
	type: Types.LEAVE_UPDATE_MODAL,
	leave,
	from,
	to,
});

const leaveUpdateTimeline = ({ leave, from, to }) => ({
	type: Types.LEAVE_UPDATE_TIMELINE,
	leave,
	from,
	to,
});

const leaveUpdateSingularBalance = (response) => ({
	type: Types.LEAVE_UPDATE_SINGULAR_BALANCE,
	response,
});

const leaveGet = (options, forModal, forTimeline) => {
	// console.log('Hola Jonathan', forModal, forTimeline);
	return (dispatch, getState) => {
		let signal = null;

		if (forModal) {
			dispatch(leaveUpdatingModal(options));
		} else if (forTimeline) {
			dispatch(leaveUpdatingTimeline(options));
		} else {
			if (getLeaveAbortController) {
				getLeaveAbortController.abort();
			}

			getLeaveAbortController = typeof "AbortController" !== "undefined" && new AbortController();
			signal = getLeaveAbortController.signal;
			dispatch(leaveUpdating(options));
		}

		// options should be cleaned only real values included
		const qs = new URLSearchParams(options).toString();

		fetch(apiURL + `/settings/leave?${qs}`, {
			credentials: "include",
			method: "GET",
			signal,
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((response) => {
				// setLeave(response.leave)
				// setLeaveLoading(false)

				if (forModal) {
					dispatch(leaveUpdateModal({ leave: response.leave, ...options }));
				} else if (forTimeline) {
					dispatch(leaveUpdateTimeline({ leave: response.leave, ...options }));
				} else {
					dispatch(leaveUpdate({ leave: response.leave, ...options }));
				}
			});
	};
};

const detailedReportDownloading = (status) => ({
	type: Types.LEAVE_DETAILED_REPORT_DOWNLOADING,
	status,
});

const downloadDetailedReport = (options) => {
	return (dispatch, getState) => {
		dispatch(detailedReportDownloading(true));

		// options should be cleaned only real values included
		const qs = new URLSearchParams(options).toString();

		fetch(apiURL + `/settings/leave/detailedReport?${qs}`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((response) => {
				if (response.signedURL) {
					const popup = window.open(response.signedURL);
					if (!popup || popup.closed || typeof popup.closed == "undefined") {
						//Worked For IE and Firefox
						alert("Popup Blocker is enabled! Please add this site to your exception list.");
					}
				} else {
					//$.notify('There was a problem creating your report.', {type:'error'});
				}

				dispatch(detailedReportDownloading(false));
			});
	};
};

const leaveTypesUpdating = () => ({
	type: Types.LEAVE_TYPES_UPDATING,
});

const leaveTypesUpdate = (leaveTypes) => ({
	type: Types.LEAVE_TYPES_UPDATE,
	leaveTypes,
});

const getSingularBalance = (id, until) => {
	return (dispatch, getState) => {
		const state = getState();

		leaveRequest({
			path: `/balance/${id}`,
			method: "GET",
			query: { includePaidOnly: true, until },
		})
			.then(({ data }) => {
				dispatch(leaveUpdateSingularBalance(data));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Getting Employee Leave Balance", "Leave Balance");
			});
	};
};

const getPublicHolidays = (date, holidayPreference) => {
	if (!date) return;
	return new Promise(async (resolve) => {
		const year = format(parse(date, "yyyy-MM-dd", new Date()), "yyyy");
		const params = constructQueryParams({ subJurisdiction: holidayPreference });
		const { holidays } = (
			await axios({
				method: "GET",
				url: apiURL + `/settings/public-holidays/${year}${params}`,
				withCredentials: true,
			})
		).data;

		resolve(holidays);
	});
};

const getLeaveBalance = (id, params) => {
	return new Promise(async (resolve) => {
		await leaveRequest({
			path: `/balance/${id}`,
			method: "GET",
			query: params,
		})
			.then(({ data }) => {
				resolve(data.leaveBalancesByType);
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Getting Employee Leave Balance", "Leave Balance");
			});
	});
};

const updateModalStatus = (leave) => {
	return async (dispatch, getState) => {
		const state = getState();
		const leaveToUse = leave || state.leave.modalLeave || {};

		const id = leaveToUse?.agreement;
		if (!id) return;
		const excludeLeaveEntry = state.leave.modalLeave?.id;
		const dateTo = state.leave.modalLeave.dateTo || format(new Date(), "yyyy-MM-dd");

		if (!dateTo) return;
		const { holidayPreference } = state.employees?.employeeListWithSalary?.find((employee) => employee.id == id);

		const holidays = await getPublicHolidays(dateTo, holidayPreference);
		const leaveBalancesByType = await getLeaveBalance(id, { excludeLeaveEntry, until: dateTo });

		dispatch(modalUpdateStatus(leaveBalancesByType, holidays));
	};
};

const getLeaveTypes = () => {
	return (dispatch, getState) => {
		dispatch(leaveTypesUpdating());

		fetch(apiURL + `/settings/leaveTypes`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((response) => {
				// setLeave(response.leave)
				// setLeaveLoading(false)

				dispatch(leaveTypesUpdate(response));
			});
	};
};

const leaveSettingsUpdating = () => ({
	type: Types.LEAVE_SETTINGS_UPDATING,
});

const leaveSettingsUpdate = (leaveSettings) => ({
	type: Types.LEAVE_SETTINGS_UPDATE,
	leaveSettings,
});

const addMultiOptionField = ({ parent, newCompany, field }) => ({
	type: Types.LEAVE_MULTI_OPTION_FIELD,
	parent,
	newCompany,
	field,
});

const getLeaveSettings = () => {
	return (dispatch, getState) => {
		dispatch(leaveSettingsUpdating());

		try {
			fetch(apiURL + `/settings/leaveSettings`, {
				credentials: "include",
				method: "GET",
				headers: {
					"Accept": "application/json",
					"Content-Type": "application/json",
				},
			})
				.then((response) => response.json())
				.then((response) => {
					// setLeave(response.leave)
					// setLeaveLoading(false)

					dispatch(leaveSettingsUpdate(response));
				});
		} catch (error) {
			console.error(error);
		}
	};
};

const leavePermissionsUpdating = () => ({
	type: Types.LEAVE_PERMISSIONS_UPDATING,
});

const leavePermissionsUpdated = (leaveTypes) => ({
	type: Types.LEAVE_PERMISSIONS_UPDATE,
	leaveTypes,
});

const saveLeavePermissions = () => {
	return (dispatch, getState) => {
		const state = getState();

		if (
			state.leave?.leaveSettings?.sickNotificationPeriods
				?.filter((period) => period.id != "Default")
				?.find((period) => !period.department)
		)
			return NotificationManager.error("Department cannot be empty ", "Sick Notification Period");
		if (state.leave?.leaveSettings?.sickNotificationPeriods?.find((period) => !period.period))
			return NotificationManager.error("Minimum Days cannot be empty", "Sick Notification Period");
		if (state.leave?.leaveTypes?.find((type) => !type.name?.replace(/\s/g, "")))
			return NotificationManager.error("Custom Leave Name cannot be empty", "Custom Leave");

		dispatch(leavePermissionsUpdating());

		fetch(apiURL + `/settings/leavePermissions`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({
				payAccruedLeave: state.leave.leaveSettings.payAccruedLeave,
				addPhToLeave: state.leave.leaveSettings.addPhToLeave,
				autoAddPublicHolidayLeave: state.leave.leaveSettings.autoAddPublicHolidayLeave,
				excludeLeaveBalance: state.leave.leaveSettings.excludeLeaveBalance,
				proRataLeave: state.leave.leaveSettings.proRataLeave || state.leave.leaveSettings.projectedBalance,
				projectedBalance: false,
				excludeLeaveBal: state.leave.leaveSettings.excludeLeaveBal,
				maxDailyLeaveHours: state.leave.leaveSettings.maxDailyLeaveHours,
				lockDate: state.leave.lockDate,
				futureLockDate: state.leave.futureLockDate,
				leaveYear: state.leave.leaveSettings.leaveYear,
				leaveYearDate: state.leave.leaveSettings.leaveYearDate,
				leaveTypes: state.leave.leaveTypes,
				sickNotificationPeriods: state.leave.leaveSettings.sickNotificationPeriods.filter(
					(period) => !!period.id,
				),
				skipAutoAddPublicHolidayLeaveForWorkedDays:
					!!state.leave.leaveSettings.skipAutoAddPublicHolidayLeaveForWorkedDays,
				defaultPH: state.leave.leaveSettings.defaultPH,
			}),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((response) => {
				// setLeave(response.leave)
				// setLeaveLoading(false)

				dispatch(leavePermissionsUpdated(response));
				dispatch(getLeaveSettings());
				dispatch(getLeaveTypes());
				NotificationManager.success("Company leave settings saved successfully!", "Saving Company Settings");
			});
	};
};

const updateSetting = (field, newValue, fieldType, id) => ({
	type: Types.LEAVE_UPDATE_FIELD,
	field,
	newValue,
	fieldType,
	id,
});

const updateLeaveModal = (field, newValue, fieldType, id) => ({
	type: Types.LEAVE_MODAL_UPDATE_FIELD,
	field,
	newValue,
});

const modalUpdateField = (field, newValue) => {
	return (dispatch, getState) => {
		const newData = { [field]: newValue };

		if (field == "hours") {
			const state = getState();
			const { date, startTime } = state.leave.modalLeave;
			let parsed = parseFloat(newValue) || 0;

			const timeIn = new Date(`${date} ${startTime}`);

			const start = timeIn.getHours() + timeIn.getMinutes() / 60;
			if (parsed > 24 || start + parsed > 24) parsed = 8;

			const newEndTime = format(
				set(timeIn, {
					hours: timeIn.getHours() + Math.trunc(parsed),
					minutes: timeIn.getMinutes() + (parsed % 1) * 60,
				}),
				"HH:mm",
			);
			newData.endTime = newEndTime;
		}

		dispatch(updateModal(newData));
	};
};

const updateModal = (details) => ({
	type: Types.LEAVE_UPDATE_MODAL_DETAILS,
	details,
});

const setModalDetailsLoading = (status) => ({
	type: Types.LEAVE_MODAL_DETAILS_LOADING,
	status,
});

const modalTimeFields = ["startTime", "endTime"];
const modalDateFields = ["date", "dateTo", "dateNotified"];
const hourlyFields = [...modalDateFields, ...modalTimeFields];

const modalUpdateDates = (field, value) => {
	return async (dispatch, getState) => {
		const state = getState();
		const data = state.leave.modalLeave;

		if (!data) return;

		const existingData = hourlyFields.reduce((a, c) => {
			if (c in data) a[c] = data[c];
			return a;
		}, {});

		if (existingData[field] === value) return;

		if (modalTimeFields.includes(field)) {
			const newDate = parse(`${data.date} ${value}`, "yyyy-MM-dd HH:mm", new Date());
			if (!isValid(newDate)) return;

			const newTimeValue = format(newDate, "HH:mm");
			existingData[field] = newTimeValue;
		}

		if (modalDateFields.includes(field)) {
			const newDate = new Date(value);
			if (!isValid(newDate)) return;

			const newDateValue = format(newDate, "yyyy-MM-dd");
			existingData[field] = newDateValue;
		}

		dispatch(setModalDetailsLoading(true));

		if (hourlyFields.includes(field)) {
			if (existingData.date > existingData.dateTo) {
				existingData.dateTo = existingData.date;
			}

			if (existingData["date"] && existingData["dateTo"]) {
				const dateYear = existingData.date.substring(0, 4);
				const dateToYear = existingData.dateTo.substring(0, 4);

				if (dateYear != dateToYear && ["date", "dateTo"].includes(field)) {
					existingData[field == "date" ? "dateTo" : "date"] = value;
				}
			}

			dispatch(updateModal(existingData));

			// state takes a while to update across devices (due to performance limitations)
			// add a delay to allow the state to update
			// to ensure the correct data is used
			await new Promise((resolve) => setTimeout(() => resolve(), 300));

			dispatch(mapBreakdown());
		}

		dispatch(setModalDetailsLoading(false));
	};
};

const getSickType = (state, modalLeave) => {
	const { date, dateNotified, type, sickChainDate } = modalLeave;
	const { hoursPerShift, notificationPeriod, hoursAvailable, halfPayBalance } =
		state.leave?.modalStatus?.employee || {};
	const { jurisdiction } = state.company.settings;

	const startDate = parse(date, "yyyy-MM-dd", new Date());
	const notifiedDate = parse(dateNotified, "yyyy-MM-dd", new Date());
	const dateNotifiedBy = addDays(startDate, notificationPeriod);
	const effectiveFromDate = notifiedDate > dateNotifiedBy ? subDays(notifiedDate, notificationPeriod) : startDate;

	let hours = hoursPerShift;
	let sickType;

	if (type == 6022)
		switch (jurisdiction) {
			case "UK":
				sickType = "US";

				if (differenceInCalendarDays(startDate, effectiveFromDate) >= 0) sickType = "WD";
				if (sickChainDate) sickType = "SSP";

				if (hoursAvailable < hours) sickType = "US";
				break;

			case "MT":
				const totalBalance = parseFloat(hoursAvailable || 0) + parseFloat(halfPayBalance || 0);
				const isHalfPay = halfPayBalance > hours - hoursAvailable;
				const isUnpaid = !isHalfPay && hours - totalBalance >= 0;
				sickType = "FP";

				if (hours >= hoursAvailable) sickType = "HP";
				if (isUnpaid) sickType = "US";

				break;
		}

	return sickType;
};

const modalUpdateDetails = (field, value) => {
	return async (dispatch, getState) => {
		const state = getState();
		const todayString = format(new Date(), "yyyy-MM-dd");

		const { hours } = state.leave?.modalLeave;

		if (state.leave?.modalDetailsLoading) return;

		const data = { ...state.leave.modalLeave };
		const dataToUpdate = {};

		if (typeof field === "string") {
			data[field] = value;
			dataToUpdate[field] = value;
		} else if (typeof field === "object") {
			Object.entries(field).forEach(([key, value]) => {
				data[key] = value;
				dataToUpdate[key] = value;
			});
		}

		const isMultiDay = data.date && data.dateTo && data.date != data.dateTo;
		const updatedType = state.leave?.modalLeave?.type != data.type;
		const updatedAgreement = state.leave?.modalLeave?.agreement != data.agreement;

		const dateWasEngagement = data.date && data.date === state.leave?.modalStatus?.employee.engagementDate;

		dispatch(setModalDetailsLoading(true));
		const userUpdatedAgreement = typeof field === "string" && ["agreement", "type"].includes(field);
		const initOfLeaveModal = typeof field === "object" && field.agreement;

		if (initOfLeaveModal || userUpdatedAgreement) {
			const id = (userUpdatedAgreement && field === "agreement" ? value : field.agreement) || data.agreement;
			const excludeLeaveEntry = data?.id;
			const dateTo = data.dateTo;

			const { holidayPreference } =
				state.employees?.employeeListWithSalary?.find((employee) => employee.id == id) || {};

			const holidays = await getPublicHolidays(dateTo, holidayPreference);
			const leaveBalancesByType = await getLeaveBalance(id, { excludeLeaveEntry, until: dateTo });

			dispatch(modalUpdateStatus(leaveBalancesByType, holidays, data));
			await new Promise((resolve) => setTimeout(() => resolve(), 600));
		}

		const newState = getState();

		if (field === "type" && value == 6022) {
			dataToUpdate.sickChainDate = await getContinuousSickDate(state);
		} else {
			dataToUpdate.sickChainDate = undefined;
		}

		if (field === "type" && value == 6022 && !isMultiDay)
			dataToUpdate.sickType = getSickType(newState, {
				...data,
				...dataToUpdate,
			});
		else dataToUpdate.sickType = undefined;

		const { hoursPerShift, engagementDate } = newState.leave?.modalStatus?.employee || {};

		if (dateWasEngagement) {
			dataToUpdate.date = todayString;
			dataToUpdate.dateTo = todayString;
		}

		if (engagementDate > data.date) {
			dataToUpdate.date = engagementDate;
			dataToUpdate.dateTo = engagementDate;
		}

		if (!isMultiDay) dataToUpdate.hours = hours && hours != hoursPerShift ? hours : hoursPerShift;

		if (field === "agreement") {
			dataToUpdate.hours = hoursPerShift;
		}

		const scheduledStartTime = 9;
		const scheduledEndTime = scheduledStartTime + (parseFloat(dataToUpdate.hours) || 0);

		dataToUpdate.startTime = format(
			set(new Date(), {
				hours: Math.trunc(scheduledStartTime),
				minutes: parseFloat((scheduledStartTime % 1).toFixed(2)) * 60,
			}),
			"HH:mm",
		);
		dataToUpdate.endTime = format(
			set(new Date(), {
				hours: Math.trunc(scheduledEndTime),
				minutes: parseFloat((scheduledEndTime % 1).toFixed(2)) * 60,
			}),
			"HH:mm",
		);

		dispatch(updateModal(dataToUpdate));

		await new Promise((resolve) => setTimeout(() => resolve(), 300));

		if (updatedType || updatedAgreement) dispatch(mapBreakdown());

		dispatch(setModalDetailsLoading(false));
	};
};

const mapBreakdown = () => ({
	type: Types.LEAVE_MODAL_MAP_BREAKDOWN,
});

const updateBreakdown = ({ dateToUseString, hours, edited, sickType, editedSickType }) => ({
	type: Types.LEAVE_MODAL_UPDATE_BREAKDOWN,
	dateToUseString,
	breakdownEntry: {
		hours,
		sickType: hours ? sickType : undefined,
		editedSickType: hours ? editedSickType : undefined,
		edited: !!edited,
	},
});

const toggleLeavePermissions = (leaveType, permission) => ({
	type: Types.LEAVE_TYPES_PERMISSIONS,
	leaveType,
	permission,
});

const setLeaveLockDate = (date) => ({
	type: Types.LEAVE_LOCK_DATE,
	date,
});

const setLeaveFutureLockDate = (date) => ({
	type: Types.LEAVE_FUTURE_LOCK_DATE,
	date,
});

// actions
const showLeaveBalanceReportModal = (status) => ({
	type: Types.LEAVE_BALANCE_REPORT_MODAL,
	status: status,
});

const setModal = (status, leave, newEntry) => ({
	type: Types.LEAVE_OPEN_MODAL,
	status: status,
	leave,
	newEntry,
});

const setOpenModal = (status, leave, newEntry) => {
	return (dispatch, getState) => {
		const state = getState();

		if (!leave) leave = {};

		const { employeeListWithSalary } = state.employees;

		const fullList = _.orderBy(
			employeeListWithSalary?.map((employee) => ({
				value: employee.id,
				label: `${employee.employeeName} ${employee.employeeSurname}`,
				terminated: employee.isTerminated,
			})) || [],
			["label", "terminated"],
			["asc", "asc"],
		);

		if (!leave?.agreement && newEntry) {
			leave.agreement = fullList[0]?.value;
		}
		if (!leave?.type && newEntry) leave.type = 6020;

		if (!leave?.date && newEntry) leave.date = format(new Date(), "yyyy-MM-dd");
		if (!leave?.dateTo && newEntry) leave.dateTo = format(new Date(), "yyyy-MM-dd");

		if (!leave?.status && newEntry) {
			leave.status = "Approved";
		}

		dispatch(setModal(status, leave, newEntry));
		dispatch(updateModalStatus(leave));
	};
};

const setFutureLeaveBalance = (status) => ({
	type: Types.LEAVE_SET_FUTURE_BALANCE,
	status: status,
});

const showCancelLeave = (leave, status) => ({
	type: Types.LEAVE_SHOW_CANCEL_LEAVE,
	status,
	leave,
});

// actions
const showComments = (leave) => ({
	type: Types.LEAVE_SHOW_COMMENTS,
	leave,
});

// actions
const showAttachments = (leave) => ({
	type: Types.LEAVE_SHOW_ATTACHMENTS,
	leave,
});

const leaveSetSaving = (id) => ({
	type: Types.LEAVE_SAVING,
	id,
});

const leaveUpdateSaveStatus = (response, leave) => ({
	type: Types.LEAVE_SAVE_CURRENT,
	payload: response,
	leave,
});

const leaveModalContinuous = (date) => ({
	type: Types.LEAVE_MODAL_CONTINUOUS,
	date,
});

const getContinuousSickDate = (state) => {
	return new Promise(async (resolve) => {
		const { date, agreement } = state.leave?.modalLeave || {};

		await settingsRequest({
			path: `/leave/continuous`,
			method: "GET",
			query: { date, agreement },
		}).then(({ data }) => {
			resolve(data.continuous);
		});
	});
};

const getContinuous = () => {
	return (dispatch, getState) => {
		const state = getState();

		const { date, agreement } = state.leave?.modalLeave || {};

		const params = new URLSearchParams({ date, agreement }).toString();

		const path = `/settings/leave/continuous?${params}`;

		fetch(apiURL + path, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				console.debug("entity data", data);
				dispatch(leaveModalContinuous(data.continuous));
			});
	};
};

const saveLeave = (leaveEntry, quickStatus) => {
	return (dispatch, getState) => {
		dispatch(leaveSetSaving());

		const state = getState();
		let hoursBreakdown;

		const leave = leaveEntry ? leaveEntry : state.leave.modalLeave;

		hoursBreakdown = Object.entries(leave.hoursBreakdown || {}).reduce((a, [dateString, v]) => {
			const { dateTo, date, startTime, endTime, type, status, source, parent, dateNotified, hours } = { ...v };
			if (!hours) return { ...a };
			return {
				...a,
				[dateString]: {
					date,
					dateTo,
					startTime,
					endTime,
					type,
					status,
					source,
					parent,
					dateNotified,
					hours,
					dateString: undefined,
					edited: undefined,
					sickType: v.editedSickType ? v.editedSickType : v.sickType,
				},
			};
		}, {});

		// dispatch(leaveSetSaving((leave?.id) || true));

		const attachments = state.leave.filesUploaded;

		const path = "/settings/leave";

		fetch(apiURL + path, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({
				...leave,
				newEntry: undefined,

				date: undefined,
				fromDate: `${leave.date} ${leave.startTime ?? "00:00"}`,

				dateTo: undefined,
				toDate: `${leave.dateTo} ${leave.endTime ?? "23:59"}`,

				hoursBreakdown: quickStatus ? undefined : hoursBreakdown,
				attachments,

				leaveType: leave.type,
				type: undefined,
				sickType: leave.editedSickType ? leave.editedSickType : leave.sickType,
			}),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(leaveGetBalances(format(new Date(), "yyyy-MM-dd")));
				dispatch(leaveUpdateSaveStatus(data, leave));
				if (leaveEntry?.childId) {
					dispatch(EMPLOYEEACTIONS.getChildren());
					dispatch(EMPLOYEEACTIONS.toggleChildLeaveModal({}));
				}
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error(`There was an error saving this Leave Entry.`, "Saving Leave");
			});
	};
};

const generatingLeaveBalanceReport = (status) => ({
	type: Types.LEAVE_GENERATING_BALANCE_REPORT,
	status,
});

const getStepFunctionState = ({ arn, name }) => {
	return (dispatch, getState) => {
		const state = getState();

		const path = `/settings/step-function-state/${arn}`;

		fetch(apiURL + path, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				console.log("entity data", data);

				const finished = data.data.status != "RUNNING";

				if (finished) {
					if (data.data.status == "SUCCEEDED") {
						if (name == "GenerateLeaveSituationReport") {
							//$.notify('Your report is ready', { type: 'success' });

							const output = JSON.parse(data.data.output);

							let popup;
							popup = window.open(output.url);
							if (!popup || popup.closed || typeof popup.closed == "undefined") {
								//Worked For IE and Firefox
								alert("Popup Blocker is enabled! Please add this site to your exception list.");
							}
							NotificationManager.success(
								"Report generated successfully!",
								"Generating Leave Situation Report",
							);
							dispatch(generatingLeaveBalanceReport(false));
						}
					} else {
						NotificationManager.error(
							"There was an error creating your report",
							"Generating Leave Situation Report",
						);
						dispatch(generatingLeaveBalanceReport(false));
					}
				} else {
					setTimeout(() => {
						dispatch(getStepFunctionState({ arn, name }));
					}, 1000);
				}
			});
	};
};

const generateLeaveBalanceReport = (options) => {
	return (dispatch, getState) => {
		const state = getState();
		let { leaveDate, department, jobType, active, includeContractors } = options;
		dispatch(generatingLeaveBalanceReport(true));

		const qs = new URLSearchParams(cleanDeep({ department, jobType, active, includeContractors })).toString();

		// let path = `/pdf/leaveReport/${leaveDate}?department=${department}&jobType=${jobType}`;
		let path = `/settings/leave/situationReport/${leaveDate}?${qs}`;

		fetch(apiURL + path, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				// dispatch(savedLead(data,label))
				console.log(data);
				const arn = data.executionArn;
				// dispatch(getLeaveBalance())
				NotificationManager.info(
					"Generating leave situation report! - This may take a while",
					"Generating Leave Situation Report",
				);

				setTimeout(() => {
					dispatch(
						getStepFunctionState({
							arn,
							name: "GenerateLeaveSituationReport",
						}),
					);
				}, 1000);
				// dispatch(contactInList({email: data.email}))
			});
	};
};

const gettingAttachment = (key) => ({
	type: Types.LEAVE_ATTACHMENT_DOWNLOADING,
	key,
});

const attachmentDownloaded = (payload, key) => ({
	type: Types.LEAVE_ATTACHMENT_DOWNLOADED,
	key,
	payload,
});

const getAttachment = (attachment) => {
	return (dispatch, getState) => {
		const state = getState();
		dispatch(gettingAttachment(attachment.key));

		const path = `/settings/getAttachment`;

		fetch(apiURL + path, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(attachment),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				console.log("entity data", data);
				dispatch(attachmentDownloaded(data, attachment.key));
			});
	};
};

const showImportModal = (status) => ({
	type: Types.LEAVE_IMPORT_SHOW_MODAL,
	status,
});

const setLeaveImportDataProcessing = (key) => ({
	type: Types.LEAVE_IMPORT_DATA_PROCESSING,
	key,
});

const setLeaveImportDataProcessed = (processed, errors, warnings) => ({
	type: Types.LEAVE_IMPORT_DATA_PROCESSED,
	processed,
	errors,
	warnings,
});

const handleLeaveUpload = ({ key, org, replaceExisting }) => {
	return (dispatch, getState) => {
		dispatch(setLeaveImportDataProcessing(key));

		const path = "/settings/upload/leave";

		fetch(apiURL + path, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({
				key,
				org,
				replaceExisting,
			}),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((res) => res.json())
			.then((data) => {
				dispatch(setLeaveImportDataProcessed(data.processed, data.errors, data.warnings));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error(`Couldn't process leave import`, "Import Leave");
				dispatch(setLeaveImportDataProcessing());
			});
	};
};

const leaveImportTemplateDownloaded = (template) => ({
	type: Types.LEAVE_IMPORT_UPLOAD_TEMPLATE,
	template,
});

const getLeaveImportTemplate = () => {
	return (dispatch, getState) => {
		fetch(apiURL + "/settings/upload/leave", {
			method: "GET",
			credentials: "include",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((res) => res.json())
			.then((data) => {
				dispatch(leaveImportTemplateDownloaded(data.template));
			})
			.catch((err) => console.error(err));
	};
};

const setFileUploading = (file, uploadType) => ({
	type: Types.LEAVE_FILE_UPLOADING,
	file,
	uploadType,
});

const setFileUploaded = (file, key, uploadType) => ({
	type: Types.LEAVE_FILE_UPLOADED,
	file,
	key,
	uploadType,
});

const uploadFile = ({ file, agreement, uploadType }) => {
	return (dispatch, getState) => {
		const state = getState();

		const path = "/settings/upload";

		// NotificationManager.success('Your File is being uploaded','Info')
		dispatch(setFileUploading(file.name, uploadType));

		fetch(apiURL + path, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({
				name: file.name,
				type: file.type,
				agreement,
			}),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				// console.log('getImportStatus', data);

				const fileKey = data.key;

				// step 1 upload to AWS
				fetch(data.url, {
					credentials: "include",
					method: "PUT",
					body: file,
					headers: {
						"Accept": "application/json",
						"Content-Type": file.type,
					},
				}).then((data) => {
					dispatch(setFileUploaded(file.name, fileKey, uploadType));
				});
			});
	};
};

const updatedLeaveRules = (rules) => ({
	type: Types.LEAVE_GET_RULES,
	rules,
});

const getLeaveRules = () => {
	return async (dispatch, getState) => {
		await leaveRequest({
			path: `/rules`,
			method: "GET",
		}).then(({ data }) => {
			dispatch(updatedLeaveRules(data));
		});
	};
};

const savedLeaveRules = (rules) => ({
	type: Types.LEAVE_SAVE_RULES,
	rules,
});

const saveLeaveRules = () => {
	return async (dispatch, getState) => {
		const state = getState();

		// only save dirty rules
		const rulesToSave = state.leave.rules.filter((r) => r.dirty);

		if (!rulesToSave.length) return;

		await leaveRequest({
			path: `/rules`,
			method: "POST",
			body: rulesToSave,
		}).then(({ data }) => {
			dispatch(savedLeaveRules(data));
		});
	};
};

const updateLeaveRule = (data) => ({
	type: Types.LEAVE_UPDATE_RULE,
	data,
});

const addLeaveRule = (data) => ({
	type: Types.LEAVE_ADD_RULE,
	data,
});

const markLeave = ({ markAs, from, to, employee }) => {
	return async (dispatch, getState) => {
		await leaveRequest({
			path: "/mark",
			method: "POST",
			body: { markAs, from, to, employee },
		})
			.then(({ data }) => {
				dispatch(saveMarkedLeave(data?.updatedLeave));
				NotificationManager.success(`Leave marked as ${markAs} successfully`, "Mark Leave");
			})
			.catch((error) => {
				NotificationManager.error(error?.response?.data?.error, "Mark Leave");
			});
	};
};

const saveMarkedLeave = (data) => ({
	type: Types.LEAVE_SAVE_MARKED,
	data,
});

const setMarkedLeaveModal = (status) => ({
	type: Types.LEAVE_SET_MARKED_MODAL,
	status,
});

const Actions = {
	modalUpdateField,
	showLeaveBalanceReportModal,
	leaveGetBalances,
	leaveGet,
	getLeaveTypes,
	toggleLeavePermissions,
	setLeaveLockDate,
	setLeaveFutureLockDate,
	saveLeavePermissions,
	getLeaveSettings,
	setOpenModal,
	saveLeave,
	showComments,
	showAttachments,
	showCancelLeave,
	getAttachment,
	showImportModal,
	handleLeaveUpload,
	getLeaveImportTemplate,
	uploadFile,
	leaveTab,
	generateLeaveBalanceReport,
	processLeaveCarryover,
	leaveGetBreakdown,
	downloadDetailedReport,
	updateSetting,
	leaveCarryoverModal,
	setMaxCarryover,
	setFutureLeaveBalance,
	getSingularBalance,
	addMultiOptionField,
	updateModalStatus,
	updateBreakdown,
	mapBreakdown,
	getContinuous,
	getChildRelatedBalance,
	modalUpdateDates,
	modalUpdateDetails,
	updateLeaveRule,
	addLeaveRule,
	getLeaveRules,
	saveLeaveRules,
	markLeave,
	saveMarkedLeave,
	setMarkedLeaveModal,
};

// exports = {
//   Types,
//   Actions
// }

export { Actions, Types };

// exports.Types = Types
// exports.Actions = Actions
